/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// lt
t.add("cart.tickets.no_available_tickets_for_seating", "Pasirinktoms vietoms biliet\u0173 n\u0117ra", "PayseraCartBundle", "lt");
t.add("cart.tickets.no_available_tickets", "Biliet\u0173 n\u0117ra", "PayseraCartBundle", "lt");
t.add("paysera_cart.discount.invalid_code", "Neteisingas nuolaidos kodas", "PayseraCartBundle", "lt");
})(Translator);
